// Browser polyfills
import 'whatwg-fetch';

// Libs
import React, { Fragment, useState } from 'react';
import { createRoot } from 'react-dom/client';

// Bridge
import { Bridge } from '@nackle/bridge';
import auth, { authRouteMiddleware, authRequestMiddleware } from './app-auth.js';

// Routing
import { Route, routeHistory, Link } from '@nackle/biw-web-router';
import { routes, bundleRoutingMiddleware } from './app-routing.jsx';

import { applyRequestMiddleware } from './fetch';

import { Layout, Menu } from 'antd';

// Styles
import './styles/app.less';


/*******************************************************************************
 *  1. App (root level component)
 */

const App = () => {
    const { Header, Footer } = Layout;
    const [ authState, setAuth ] = useState( {} );

    const handleSignIn = async ( authState ) => {
        setAuth( authState );
    };

    return (
        <Layout className='app-root'>
            <Bridge
                autoSignIn={ true }
                auth={ auth }
                requiresAuth={ true }
                onSignIn={ handleSignIn }
                onRefresh={ handleSignIn } >

                <Header>
                    <div className="logo" />
                    <Menu theme="dark" mode="horizontal" defaultSelectedKeys={ [ '1' ] }>
                        <Menu.Item key="1">
                            <Link to="/home">Home</Link>
                        </Menu.Item>
                        <Menu.Item key="2">
                            <Link to="/about">About</Link>
                        </Menu.Item>
                    </Menu>
                </Header>

                <Route render={ ( route ) => {
                    document.title = route && route.match ? route.match.title : 'Some default page title';

                    return route.match &&
                        <Fragment>
                            { React.cloneElement( route.component, {
                                className: getRouteClassName( route.pathname, 'view' ),
                                auth: authState,
                                locale: 'en-US'
                            } ) }
                        </Fragment>;
                } }/>

            </Bridge>

            <Footer style={ { textAlign: 'center' } }>© { new Date().getFullYear() } BI WORLDWIDE™ All Rights Reserved.</Footer>

        </Layout>
    );

};

const getRouteClassName = ( pathname, prefix ) => {
    const classList = [ prefix ];

    // let prefix = '--';
    prefix = `${ prefix }-`;
    pathname.substring( 1 ).split( '/' ).forEach( ( part ) => {
        classList.push( `${ prefix }${ part }` );
        prefix = `${ prefix }${ part }-`;
    } );

    return classList.join( ' ' );
};

/*******************************************************************************
 *  2. Connect Routing
 */
routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( [ authRouteMiddleware, bundleRoutingMiddleware ] );

/*******************************************************************************
 *  3. Connect Auth to Fetch
 */
applyRequestMiddleware( authRequestMiddleware );

/*******************************************************************************
 * 4. Render
 */

const container = document.getElementById( 'app-root' );
const root = createRoot( container );
root.render( <App /> );